import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { CompanyParamsService } from '../../services/company-params.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'is-what';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Subject, takeUntil } from 'rxjs';
import { AuthLoginService } from 'src/app/modules/auth/services/auth-login.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    imports: [NgIf]
})
export class LogoutComponent implements OnInit, OnDestroy {

  isLogged = signal(false);
  isOpen = signal(false);
  username = signal('');
  private destroyed$ = new Subject<void>();
  mainColor: any;

  constructor(
    public companyParamsService: CompanyParamsService,
    public router: Router,
    public localStorageService: LocalStorageService,
    public authLoginService: AuthLoginService
  ) { }

  ngOnInit(): void {
    this.mainColor = "#"+this.companyParamsService.getMainColor();
    this.checkLoggedIn();
    this.localStorageService.watchStorage().pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.checkLoggedIn();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  logout(): void {
    this.localStorageService.removeData(this.companyParamsService.getCode() + '-loginToken');
    this.isLogged.set(false);
    this.isOpen.set(false);
    this.router.navigateByUrl('/' + this.companyParamsService.getNameUrl() + '/search');
  }

  toggleDropdown(): void {
    this.isOpen.update(open => !open);
  }

  checkLoggedIn(): void {
    if (typeof localStorage === 'undefined') return;
    const token = this.localStorageService.getData(this.companyParamsService.getCode() + '-loginToken');
    const isLogged = !isNullOrUndefined(token);
    this.isLogged.set(isLogged);
    this.username.set(
      isLogged && token ? this.authLoginService.decodeToken(token)?.name ?? '' : ''
    );
  }

}
